import React, { useEffect, useState } from 'react'
import * as S from './styles'

import { useTranslation } from 'react-i18next'

const CustomPhysiology = () => {
  const { t } = useTranslation()

  const [text1, setText1] = useState('')
  const [text2, setText2] = useState('')
  const [text3, setText3] = useState('')
  const [text4, setText4] = useState('')
  const [text5, setText5] = useState('')
  const [text6, setText6] = useState('')

  useEffect(() => {
    setText1(t('titles.cardiacCycle'))
    setText2(t('titles.fiberContraction'))
    setText3(t('titles.potentialGeneration'))
    setText4(t('titles.hematosis'))
    setText5(t('titles.synapticTransmission'))
    setText6(t('titles.lungVentilation'))
  }, [t])

  return (
    <S.CustomPhysiologyContainer>
      <li>{text1}</li>
      <li>{text2}</li>
      <li>{text3}</li>
      <li>{text4}</li>
      <li>{text5}</li>
      <li>{text6}</li>
    </S.CustomPhysiologyContainer>
  )
}

export default CustomPhysiology
